import { render } from "./SettingsTab.vue?vue&type=template&id=4ce304c4&scoped=true"
import script from "./SettingsTab.vue?vue&type=script&lang=js"
export * from "./SettingsTab.vue?vue&type=script&lang=js"

import "./SettingsTab.vue?vue&type=style&index=0&id=4ce304c4&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce304c4"]])

export default __exports__